import { newSendApiRequest } from './service-gateway';
import { USER_ACTIVITY_TYPES } from '../constants/index';

export const recordUserActivity = async (token, activityType, activityDetails) => {
    try {
        const userActivity = { activityType };

        if (activityDetails) {
            userActivity.activityDetails = typeof activityDetails === 'string'
                ? activityDetails
                : JSON.stringify(activityDetails);
        }

        return await newSendApiRequest(
            'UserActivity_log',
            [{ parameter: 'user_activity', value: JSON.stringify(userActivity) }],
            10000,
            token
        );
    } catch (error) {
        console.error(error);
    }
};

export const recordLoginActivity = async (token) => {
    const activityDetails = {
        page: '/dashboard',
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : 'Unknown',
    };

    return await recordUserActivity(token, USER_ACTIVITY_TYPES.LOGIN, activityDetails);
};
